import Tooltip from 'components/Tooltip'
import React from 'react'
import { QuestionCircleFill } from 'react-bootstrap-icons'
import styles from './Help.module.scss'

function DistributorHelp(props) {
  return (
    <Tooltip label='Limit which distributors will see this package, leave empty to allow it for all distributors.'>
      <span className={styles.help}>
        <QuestionCircleFill />
      </span>
    </Tooltip>
  )
}

export default DistributorHelp
